import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { Product } from '../types';
import { productService } from '../services/productService';

interface PackItem {
  id: string;
  quantity: number;
  name: string;
  price: number;
  image: string;
}

export const ProductDetail = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const [quantity, setQuantity] = useState(1);
  const [product, setProduct] = useState<Product | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [packItems, setPackItems] = useState<PackItem[]>([]);
  const [loadingPackItems, setLoadingPackItems] = useState(true);

  useEffect(() => {
    const fetchProduct = async () => {
      if (!id) return;
      
      try {
        setLoading(true);
        const fetchedProduct = await productService.getProduct(id);
        if (!fetchedProduct) {
          setError('Produit non trouvé');
          return;
        }
        setProduct(fetchedProduct);


console.log('Alors, ca veut regarder dans la console ?')

        // Si c'est un pack, utiliser directement les données reçues
        if (fetchedProduct.is_pack && Array.isArray(fetchedProduct.pack_items) && fetchedProduct.pack_items.length > 0) {
          console.log('Entrée dans la condition du pack');
          setLoadingPackItems(true);
          try {
            console.log('Pack items reçus:', fetchedProduct.pack_items);
            const items = await Promise.all(
              fetchedProduct.pack_items.map(async (item) => {
                const product = await productService.getProduct(item.id);
                console.log('Product:', product);
                console.log('Quantity:', item.quantity);
                return { ...product, quantity: item.quantity };
              })
            );
            console.log('Articles du pack chargés:', items);
            setPackItems(items);
          } catch (err) {
            console.error('Erreur lors de la récupération des articles du pack:', err);
            setError('Erreur lors du chargement des articles du pack');
          }
        } else {
          console.log('Pas entré dans la condition du pack');
          console.log('Raison:', !fetchedProduct.is_pack ? 'is_pack est false' : 'pack_items est vide ou non tableau');
        }
      } catch (err) {
        setError('Erreur lors du chargement du produit');
        console.error(err);
      } finally {
        setLoading(false);
        setLoadingPackItems(false);
      }
    };

    fetchProduct();
  }, [id]);

  if (loading) {
    return (
      <div className="pt-16 min-h-screen bg-gradient-to-br from-orange-50 to-pink-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-500"></div>
      </div>
    );
  }

  if (error || !product) {
    return (
      <div className="pt-16 min-h-screen bg-gradient-to-br from-orange-50 to-pink-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Produit non trouvé</h1>
          <button
            onClick={() => navigate('/store')}
            className="text-pink-500 hover:text-pink-600"
          >
            Retourner à la boutique
          </button>
        </div>
      </div>
    );
  }

  if (!product.is_available) {
    return (
      <div className="pt-16 min-h-screen bg-gradient-to-br from-orange-50 to-pink-50 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Produit non disponible</h1>
          <button
            onClick={() => navigate('/store')}
            className="text-pink-500 hover:text-pink-600"
          >
            Retourner à la boutique
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-16 min-h-screen bg-gradient-to-br from-orange-50 to-pink-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Bouton de retour */}
        <button
          onClick={() => navigate('/store')}
          className="mb-4 px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
        >
          Retour à la boutique
        </button>
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="md:flex">
            <div className="md:flex-shrink-0">
              <img
                className="h-96 w-full object-cover md:w-96"
                src={product.image}
                alt={product.name}
              />
            </div>
            <div className="p-8">
              <div className="uppercase tracking-wide text-sm text-pink-500 font-semibold">
                {product.category === 'merch' ? 'Merchandising' : 
                 product.category === 'drinks' ? 'Forfait Boissons' : 'Pack'}
              </div>
              <h1 className="mt-2 text-3xl font-bold text-gray-900">{product.name}</h1>
              <p className="mt-4 text-xl text-gray-500">{product.description}</p>
              
              {product.is_pack && (
                <div className="mt-6">
                  <h2 className="text-lg font-semibold text-gray-900">Articles inclus</h2>
                  {loadingPackItems ? (
                    <div className="animate-pulse space-y-2">
                      <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                      <div className="h-4 bg-gray-200 rounded w-1/2"></div>
                    </div>
                  ) : packItems.length > 0 ? (
                    <div className="mt-4 space-y-4">
                      {packItems.map((item) => (
                        <div key={item.id} className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                          <div className="flex items-center space-x-4">
                            <img 
                              src={item.image} 
                              alt={item.name}
                              className="w-12 h-12 object-cover rounded"
                            />
                            <div>
                              <span className="font-medium">{item.name}</span>
                              <span className="text-gray-500 ml-2">x{item.quantity}</span>
                            </div>
                          </div>
                          <span className="text-gray-600">{item.price}€</span>
                        </div>
                      ))}
                      <div className="mt-4 p-3 bg-gray-100 rounded-lg">
                        <div className="flex justify-between items-center">
                          <span className="font-medium">Prix total théorique:</span>
                          <span className="text-lg font-semibold">
                            {packItems.reduce((total, item) => total + (item.price * item.quantity), 0).toFixed(2)}€
                          </span>
                        </div>
                        <div className="mt-2 flex justify-between items-center text-green-600">
                          <span>Économie:</span>
                          <span className="font-semibold">
                            {(packItems.reduce((total, item) => total + (item.price * item.quantity), 0) - product.price).toFixed(2)}€
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <p className="text-gray-500 mt-2">Aucun article inclus dans ce pack</p>
                  )}
                </div>
              )}

              <div className="mt-8 flex items-center justify-between">
                <div>
                  <span className="text-3xl font-bold text-pink-500 pr-8">{product.price}€</span>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="flex items-center border rounded-lg">
                    <button
                      onClick={() => setQuantity(Math.max(1, quantity - 1))}
                      className="px-4 py-2 text-gray-600 hover:text-pink-500"
                    >
                      -
                    </button>
                    <span className="px-4 py-2 text-gray-900">{quantity}</span>
                    <button
                      onClick={() => setQuantity(Math.min(product.stock, quantity + 1))}
                      className="px-4 py-2 text-gray-600 hover:text-pink-500"
                    >
                      +
                    </button>
                  </div>
                  <button
                    onClick={() => addToCart(product, quantity)}
                    className="px-8 py-3 bg-pink-500 text-white rounded-lg hover:bg-pink-600 transition-colors"
                  >
                    Ajouter au panier
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}